// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4876":"62252f7f65229eaf","5129":"d9c8c9b90eff277f"}[chunkId] + ".css";
};